import React, { useState, useEffect, Fragment } from "react";
import useRequireAuth from "../../utils/useRequireAuth";

import { useFetchCompanyDelegationQuery } from "../../utils/customer/customerTaskTable";

import useFullscreen from "../../hooks/Screen/FullCloseScreen";
import LayoutHOC from "../LayoutHOC";
import AddUpdateCompanyDelegation from "./AddUpdateCustomerDelegation";
import { useLocation } from "react-router-dom";
import { getUserTokeData } from "../../utils/userSlice";
import { useDispatch, useSelector } from "react-redux";
import { DELETE_ACCESS } from "../../utils/constants";
import { deleteData } from "../store/customer/CustomerSocialAddUpdateFunction";
import { pushAlert } from "../../utils/alertSlice";
import ReactTableComponent from "../UniversalComponents/ReactTableComponent";
import { getCompanyId } from "../../utils/utilityFunctions/localServices";
import deleteIcon from "../../assets/images/deleteIconCoaTable.svg";
import { showLoader, hideLoader } from "../../utils/loaderSlice";
import { ReactComponent as EmailIcon } from "../../assets/images/emailCustomerCard.svg";
import CopyIconComponent from "../UniversalComponents/CopyIconComponent";
import { ReactComponent as PhoneIcon } from "../../assets/images/PhoneIconCustomerCard.svg";
import UserNameHover from "../User/UserNameHover";
import { getInitials } from "../../utils/utilityFunctions/stringUtility";
import AvatarName from "../UniversalComponents/AvatarName";

const CompanyDelegation = ({}) => {
  const [customerTablePagination, setCustomerTablePagination] = useState("");
  const { isFullscreen, toggleFullscreen } = useFullscreen();
  const [customer, setCustomer] = useState([]);
  const [initialFilter, setInitialFilter] = useState([]);
  const [loading, setLoading] = useState(false);
  const { token } = useRequireAuth();
  const [alert, setAlert] = useState({ visible: false, message: "", type: "" });

  const [editData, setEditData] = useState();
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const location = useLocation();
  const dispatch = useDispatch();
  const [totalData, setTotalData] = useState();
  const {
    data: customerTableALL,
    refetch: refetchCustomerData,
    isFetching: companyDelegationLoading,
  } = useFetchCompanyDelegationQuery({
    token: token,
    pagination: `?company_id=${getCompanyId()}`,
  });

  useEffect(() => {
    if (companyDelegationLoading) {
      dispatch(showLoader());
    } else {
      dispatch(hideLoader());
    }
  }, [companyDelegationLoading]);

  useEffect(() => {
    if (customerTableALL) {
      const { data, ...restData } = customerTableALL?.data;
      setCustomer(data);
      setTotalData(customerTableALL?.data?.total);
      setInitialFilter(restData);
      setLoading(false);
    }
  }, [customerTableALL, customerTablePagination, refetchCustomerData, location.key]);
  const handleNavigate = (taskid) => {
    setEditData(taskid);
  };
  const hideAlert = () => {
    setAlert((prevState) => ({ ...prevState, visible: false }));
  };
  const onClose = () => {
    setIsPopupOpen(false);
    setEditData("");
  };

  const handelRegenerat = () => {
    refetchCustomerData();
  };

  const openPopup = () => {
    setIsPopupOpen(true);
  };

  useEffect(() => {
    if (location.key) {
      refetchCustomerData();
      dispatch(getUserTokeData());
    }
  }, [location.key]);
  const companyLocalData = localStorage?.getItem("company_data");

  const parsedCompanyData = JSON.parse(companyLocalData);

  const handleDelete = async (item) => {
    const id = item?.customer_id;
    const url = `${DELETE_ACCESS}`;

    const payload = {
      email: item?.email,
      user_id: id,
      company_id: parsedCompanyData?.company_id,
      group_id: item?.group_id,
    };

    let response = await deleteData(url, token, payload, "POST");

    if (response.message === "Operation successful") {
      refetchCustomerData();
      dispatch(pushAlert({ message: "User deleted successfully", type: "success", visible: true }));
    } else {
      dispatch(pushAlert({ message: "Something went wrong", type: "danger", visible: true }));
    }
  };

  const HoverCard = ({ name, emailID, mobile, handleCLick }) => {
    return (
      <div className="py-2 min-w-[17.78rem]">
        <div className="rounded-lg bg-white">
          <div className="border-b-2 space-y-2 pb-2">
            <div className="flex px-2 space-x-2">
              <div>
                <div className="">
                  <AvatarName
                    name={getInitials(name)}
                    size="small"
                    bgColor={"#E8ECF299"}
                    textColor={"#7C7C83"}
                    borderColor={"#ABABAC"}
                  />
                </div>
              </div>
              <div className="text-2999BC text-14">{name || "-"}</div>
            </div>

            <div className="flex px-2 space-x-2 my-2">
              <div className="w-5 text-center">
                <EmailIcon />
              </div>
              <div className="text-F16136 text-12">{emailID || "-"}</div>
            </div>

            <div className="flex px-2 space-x-2 my-2">
              <div className="w-5 text-center">
                <PhoneIcon />
              </div>
              <div className="text-F16136 text-12">{mobile || "-"}</div>
            </div>
          </div>
          {/* <div className="flex justify-end mt-2 me-5 text-12">
            <button className="text-blue-500" onClick={() => console.log("helllo")}>
              Show more
            </button>
          </div> */}
        </div>
      </div>
    );
  };

  return (
    <Fragment>
      <div className="px-2 py-1 h-full" id="innercontent gg">
        <div id="default-styled-tab-content" className="tablemaindiv h-full">
          <div className="profile h-full" id="styled-profile" role="tabpanel" aria-labelledby="profile-tab">
            <div className={` flex flex-col h-full ${isFullscreen ? "bg-white h-full" : ""}`}>
              {customer && (
                <ReactTableComponent
                  tablename="Company Delegation"
                  headers={[
                    {
                      accessor_key: "user_name",
                      label: "User Name",
                      callingFunction: (item) => {
                        setIsPopupOpen(true);
                        setEditData(item);
                      },
                      // tooltip:(data) => <UserNameHover name ={data?.data?.user_name} emailID={data?.data?.email} mobile={data?.data?.mobile} />},
                      tooltip: (data) => (
                        <HoverCard
                          name={data?.data?.user_name}
                          emailID={data?.data?.email}
                          mobile={data?.data?.mobile}
                        />
                      ),
                    },
                    {
                      accessor_key: "email",
                      label: "Email",
                      SecondClickHandler: () => console.log("Called Column Function"),
                    },
                    {
                      accessor_key: "department",
                      label: "Department",
                      // callingFunction: () => console.log("Called Column Function"),
                    },
                    {
                      accessor_key: "designation",
                      label: "Designation",
                      // callingFunction: () => console.log("Called Column Function"),
                    },
                    {
                      accessor_key: "reporting",
                      label: "Reporting",
                      callingFunction: () => console.log("Called Column Function"),
                      tooltip: (data) => (
                        <HoverCard
                          name={data?.data?.reporting}
                          emailID={data?.data?.manager_email}
                          mobile={data?.data?.manager_phone}
                        />
                      ),
                      // tooltip: (data) => console.log(data, "companydata"),
                    },
                    {
                      accessor_key: "access_type",
                      label: "Access",
                      // callingFunction: () => console.log("Called Column Function"),
                    },
                  ]}
                  body={customer}
                  isDeletable={(data) => handleDelete(data)}
                  actionField={
                    <div className="flex items-center gap-2">
                      <div>
                        <button
                          onClick={() => setIsPopupOpen(true)}
                          className="border-[#EBF2F6] rounded-md hover:bg-[#CECECE4D] hover:border-transparent"
                        >
                          <i className={`bi bi-plus-lg text-2541558A  hover:text-254155`}></i>
                        </button>
                      </div>
                      <div>
                        <button className="border-[#EBF2F6] rounded-md hover:bg-[#CECECE4D] hover:border-transparent">
                          <i
                            className={` bi bi-list tableheadermenuicon tableheaderfiltericon  hover:text-254155 group-focus-within:text-white text-2541558A  `}
                          ></i>
                        </button>
                      </div>
                    </div>
                  }
                />
              )}
            </div>
          </div>
        </div>
        {isPopupOpen && (
          <AddUpdateCompanyDelegation
            isOpen={isPopupOpen}
            onClose={onClose}
            handleSubmitData={handelRegenerat}
            editData={editData}
          />
        )}
      </div>
    </Fragment>
  );
};

export default LayoutHOC(CompanyDelegation);
